<template>
  <v-container>
    <v-card>
      <v-card-text>
        <h2 class="text-center">
          Conditions générales d'utilisation du site R’Cog
        </h2>
        <br />
        <hr />
        <br />
        <h3>La plateforme R’Cog</h3>
        <br />
        <p>
          R’Cog est une plateforme collaborative qui centralise les créations en
          rééducation cognitive. Elle vous aide à partager vos créations
          thérapeutiques et à vous inspirer des idées créatives d’autres
          thérapeutes de France ou d’autres pays. Pour vous permettre d’accéder
          à cet espace d’échange et d’enrichissement thérapeutique nous avons
          besoin de vous connaitre davantage et d’être certain que vous êtes
          bien diplômé ou étudiant en psychologie. Dans le cadre de cette
          plateforme, nous essayons de faire en sorte que le contenu soit
          contrôlé et le plus pertinent possible sur le plan théorique et
          scientifique. Cette plateforme vise à promouvoir l’utilisation d’un
          pratique basée sur les faits ou Evidence Based Pratice (EBP).
        </p>
        <h3>Article 1 : Objet</h3>
        <br />
        <p>
          Les présentes « Conditions Générales d'Utilisation » ou CGU ont pour
          objet l'encadrement juridique de l’utilisation de R’Cog et de ses
          services ci-dessous désigné « le Site ».
        </p>
        <p>
          Ce contrat est conclu entre :
        </p>
        <p>
          Nicolas DELEPLACE et Anthony DELEPLACE, ci-après désigné les «
          Éditeurs », Toute personne physique ou morale souhaitant accéder au
          site et à ses services, ci-après appelé « l’Utilisateur ».
        </p>
        <p>
          Les conditions générales d'utilisation doivent être acceptées par tout
          Utilisateur, et son accès au site vaut acceptation de ces conditions.
          Autrement dit, l’accès à cette plateforme signifie l’acceptation des
          présentes CGU.
        </p>
        <h3>Article 2 : Mentions légales</h3>
        <br />
        <p>
          Le site R’Cog est développé et édité par Nicolas DELEPLACE et Anthony
          DELEPLACE, tous deux de nationalité française.
        </p>
        <h3>Article 3 : Accès aux services</h3>
        <br />
        <p>
          Dans le but de fournir un contenu de qualité, seuls les thérapeutes
          diplômés en psychologie avec une spécialité en neuropsychologie ainsi
          que les étudiants en deuxième année de master avec une spécialité en
          neuropsychologie pourront également avoir accès à l’inscription.
        </p>
        <p>
          Nous avons fait le choix de laisser toutes les fonctionnalités de base
          gratuites sur R’Cog. Toutefois, des fonctionnalités avancées et
          payante pourrons voir le jour. Ce système nous permettra de financer
          les coûts d’hébergement du serveur et de vous fournir la meilleure
          expérience utilisateur possible en veillant à ne pas utiliser de
          contenu publicitaire.
        </p>
        <p>
          Tout Utilisateur ayant accès à internet peut accéder gratuitement et
          depuis n’importe où au site. Les frais supportés par l’Utilisateur
          pour y accéder (connexion internet, matériel informatique, etc.) ne
          sont pas à la charge des Éditeurs.
        </p>
        <p>
          Les services suivants ne sont accessibles pour l’Utilisateur à la
          condition qu’il soit membre du site (c’est-à-dire qu’il est identifié
          à l’aide de ses identifiants de connexion) :
        </p>
        <ul>
          <li>
            Publication d’activités et de différents supports téléchargeables
          </li>
          <li>
            Lecture et téléchargement d’activités
          </li>
          <li>
            Publication de commentaires sur les activités
          </li>
          <li>
            Retour d’efficacité sur les activités
          </li>
        </ul>

        <p>
          Le site et ses différents services peuvent être interrompus ou
          suspendus par les Éditeurs, notamment à l’occasion d’une maintenance,
          sans obligation de préavis ou de justification.
        </p>

        <h3>Article 4 : Responsabilité de l'Utilisateur</h3>
        <br />
        <p>
          L'Utilisateur est responsable des risques liés à l’utilisation de son
          identifiant de connexion et de son mot de passe. Le mot de passe de
          l’Utilisateur doit rester secret. En cas de divulgation de mot de
          passe, l’Éditeur décline toute responsabilité.
        </p>
        <p>
          L’Utilisateur assume l’entière responsabilité de l’utilisation qu’il
          fait des informations et contenus présents sur le site R’Cog.
        </p>
        <p>
          R’Cog vous permet de publier du contenu thérapeutique, y compris des
          photos, des commentaires, des liens et d’autres documents. Tout
          élément que vous publiez ou divulguez d'une quelconque autre manière
          sur R’Cog est appelé « contenu utilisateur ». Vous conservez tous les
          droits et êtes uniquement responsable du contenu utilisateur que vous
          publiez sur R’Cog. Toutefois, aucune information pouvant porter
          atteinte au secret professionnel ne pourra être divulguée dans le
          contenu de l’activité, dans les commentaires ou tout autre lieu de
          publication du Site sous peine d’une suppression sans obligation de
          justification.
        </p>
        <p>
          Vous accordez à R’Cog et aux utilisateurs un contenu libre de droit et
          protéger sous licence Creative Commons, celui-ci peut être
          transférable, modifiable et non réutilisé de façon commerciale. Nous
          nous réservons le droit de supprimer le contenu utilisateur sans
          obligation de justification. Cette règle vaut pour le contenu
          utilisateur qui vont à l’encontre les présentes conditions ou toutes
          autres politiques du site.
        </p>
        <p>
          L’avis des différents thérapeutes est précieux, et nous sommes
          toujours curieux des retours d’expériences et des modifications utiles
          que pourrait apporter la communauté sur une activité. Si vous décidez
          de publier des commentaires, des idées ou des réactions, vous acceptez
          que nous soyons libres de les utiliser sans restriction ou sans vous
          rémunérer. Les Éditeurs s'engagent à citer le membre en cas
          d’utilisation de sa publication.
        </p>
        <h3>
          Article 5 : Responsabilité des éditeurs
        </h3>
        <br />
        <p>
          Tout dysfonctionnement du serveur ou du réseau ne peut engager la
          responsabilité des Éditeurs.
        </p>
        <p>
          De même, la responsabilité du site ne peut être engagée en cas de
          force majeure ou du fait imprévisible et insurmontable d'un tiers.
        </p>
        <p>
          Le site R’Cog s'engage à mettre en œuvre tous les moyens nécessaires
          pour garantir la sécurité et la confidentialité des contenus et des
          comptes de ses utilisateurs. Toutefois, il n’apporte pas une garantie
          de sécurité totale. Nous vous demandons de veiller à la
          confidentialité de votre mot de passe. Veuillez nous informer
          immédiatement en cas d’utilisation non autorisée de votre compte ou de
          piratage.
        </p>
        <p>
          Les Éditeurs se réservent la faculté d’une non-garantie de la
          fiabilité des sources, bien que les informations diffusées sur le site
          soient réputées fiables. R’Cog n’assume aucune responsabilité pour le
          contenu utilisateur qu’un tiers, une autre personne ou vous-même
          publiez ou envoyez via notre service.
        </p>
        <p>
          Après avoir clôturé ou désactivé votre compte ou si vous supprimez du
          contenu utilisateur de R’Cog, il se peut que nous conservions votre
          contenu utilisateur pour une période raisonnable à des fins de
          sauvegarde, d’archivage ou de contrôle. R’Cog et ses utilisateurs
          peuvent conserver et continuer d’utiliser, sauvegarder, afficher et
          exécuter tout contenu utilisateur vous appartenant.
        </p>
        <p>
          Nous pouvons résilier ou suspendre vos droits d’accès ou d’utilisation
          de R’Cog pour quelque raison que ce soit, moyennant un avis approprié.
          Nous pouvons mettre un terme ou suspendre votre accès immédiatement et
          sans préavis pour un motif valable tel qu’une violation de nos
          conditions d’utilisation.
        </p>

        <h3>Article 6 : Propriété intellectuelle</h3>
        <br />
        <p>
          Les contenus du site R’Cog (logos, textes, éléments graphiques,
          vidéos, etc.) sont protégés par le droit d’auteur, en vertu du Code de
          la propriété intellectuelle.
        </p>
        <p>
          L’Utilisateur devra obtenir l’autorisation de l’éditeur du site avant
          toute reproduction, copie ou publication de ces différents contenus.
        </p>
        <p>
          Ces derniers peuvent être utilisés par les utilisateurs à des fins
          privées ; tout usage commercial est interdit.
        </p>
        <p>
          L’Utilisateur est entièrement responsable de tout contenu qu’il met en
          ligne, il s’engage à ne pas porter atteinte à un tiers et à respecter
          le
          <a
            href="www.codededeontologiedespsychologues.fr/IMG/pdf/Code_deontologie_psychologue_9-09-2021.pdf"
            >code de déontologie des Psychologues</a
          >
          à jour.
        </p>
        <p>
          Les Éditeurs du site se réserve le droit de modérer ou de supprimer
          librement et à tout moment les contenus mis en ligne par les
          utilisateurs, et ce sans justification.
        </p>
        <p>
          R’Cog a adopté et mis en place une politique relative au droit
          d’auteur conforme au Creative Commons et à d’autres lois applicables
          en matière de droits d’auteurs. De sorte à laisser libre de droit le
          contenu utilisateur exposé tout en interdisant sa réutilisation
          commerciale. L’utilisation de matériels protégés par les droits
          d’auteurs est autorisée uniquement si la référence est clairement
          explicitée avec mention du sigle © ou ® en citant la source.
        </p>
        <h3>Article 7 : Données personnelles</h3>
        <br />
        <p>
          L’avis des différents thérapeutes est précieux, et nous sommes
          toujours curieux des retours d’expériences et des modifications utiles
          que pourrait apporter la communauté sur une activité. Si vous décidez
          de publier des commentaires, des idées ou des réactions, vous acceptez
          que nous soyons libres de les utiliser sans restriction ou sans vous
          rémunérer. En d'autres termes : Vos suggestions seront utiles pour
          améliorer le contenu utilisateur de chacun et nous pouvons les
          utiliser pour améliorer R’Cog.
        </p>
        <p>
          L’Utilisateur doit obligatoirement fournir des informations
          personnelles pour procéder à son inscription sur le site.
        </p>
        <p>
          L’adresse électronique (e-mail) de l’utilisateur pourra notamment être
          utilisée par le Site pour la communication d’informations diverses et
          la gestion du compte.
        </p>
        <p>
          R’Cog garantie le respect de la vie privée de l’utilisateur,
          conformément à la loi n°78-17 du 6 janvier 1978 relative à
          l'informatique, aux fichiers et aux libertés.
        </p>
        <p>
          Le site suit les recommandations du Règlement Général sur la
          Protection des Données (RGPD).
        </p>
        <p>
          En vertu des articles 39 et 40 de la loi en date du 6 janvier 1978,
          l'Utilisateur dispose d'un droit d'accès, de rectification, de
          suppression et d'opposition de ses données personnelles. L'Utilisateur
          exerce ce droit via :
        </p>
        <ul>
          <li>
            Un formulaire de contact ;
          </li>
          <li>
            Par mail à contact.rcog@gmail.com ;
          </li>
        </ul>
        <br />
        <h3>Article 8 : Liens hypertextes</h3>
        <br />
        <p>
          R’Cog peut contenir des liens vers des sites Web ou liens hypertextes.
          Nous n’engageons en aucun cas notre responsabilité en ce qui concerne
          ces sites, informations ou documents. Si vous accédez à un site Web,
          un service ou un contenu externe depuis R’Cog, vous le faites à vos
          propres risques et vous acceptez que la responsabilité de R’Cog ne
          soit pas engagée si vous accédez ou utilisez ces sites Web, services
          ou contenus de tierces parties.
        </p>
        <p>
          Il est possible pour un tiers de créer un lien vers une page du site
          R’Cog sans autorisation expresse des Éditeurs.
        </p>
        <h3>Article 9 : Évolution des conditions générales d’utilisation</h3>
        <br />
        <p>
          Les Éditeurs se réservent le droit de déterminer la forme et les
          moyens de vous transmettre des notifications, et vous acceptez de
          recevoir des avis légaux par voie électronique si nous choisissons de
          procéder de la sorte.
        </p>
        <p>
          Le site R’Cog se réserve le droit de modifier les clauses de ces
          conditions générales d’utilisation à tout moment et sans
          justification. La version la plus récente sera toujours affichée sur
          notre site Web. Vous serez informé de toute modification de ces
          conditions. En continuant d’accéder à R’Cog ou de l’utiliser après
          l’entrée en vigueur de ces modifications, vous acceptez de fait d’être
          lié par ces conditions modifiées. Si vous n’acceptez pas les nouvelles
          conditions, veuillez cesser d’utiliser R’Cog.
        </p>
        <h3>Article 10 : Durée du contrat</h3>
        <br />
        <p>
          La durée du présent contrat est indéterminée. Le contrat produit ses
          effets à l'égard de l'Utilisateur à compter du début de l’utilisation
          du service.
        </p>
        <h3>Article 11 : Droit applicable et juridiction compétente</h3>
        <br />
        <p>
          Le présent contrat dépend de la législation française.
        </p>
        <p>
          En cas de litige entre l’Utilisateur et les Éditeurs, vous acceptez de
          nous contacter d’abord pour tenter de résoudre le problème à
          l’amiable. Si nous devons vous contacter, nous utiliserons l’adresse
          électronique qui figure sur votre compte R’Cog. Si R’Cog n’a pas été
          capable de résoudre le litige à l’amiable avec vous, les tribunaux de
          la ville de Laon sont compétents pour régler le contentieux.
        </p>
        <h2>Annexe 1 - Guide pour les utilisateurs</h2>
        <br />
        <p>
          L’objectif de R’Cog est de pouvoir élaborer une bibliothèque de
          ressources collaborative en intervention cognitive fondée sur les
          preuves scientifiques. Toutefois, tous les contenus ne sont pas
          pertinents. Nous avons mis en place le guide des utilisateurs
          ci-dessous pour définir ce que nous autorisons et ce que nous
          n'autorisons pas sur R’Cog. Pour faire évoluer ces restrictions nous
          utilisons vos retours, nous vous invitons donc fortement à nous faire
          part de tout contenu qui vous parait sensible.
        </p>
        <h3>Sécurité du contenu</h3>
        <br />
        <p>
          R’Cog n'est pas un support autorisant un contenu ou un comportement
          erroné ou trompeur, hostile, explicite, haineux ou violent. Nous
          pouvons supprimer ou bloquer sans justification la publication de ces
          contenus et des comptes qui les créent ou les publient.
        </p>
        <p>
          R’Cog n'est pas un support autorisant à insulter des individus, à leur
          nuire ou à se montrer hostile envers eux. La critique est permise mais
          nous supprimerons tout contenu insultant.
        </p>
        <p>
          Nous n'autorisons pas le contenu qui révèle des informations
          personnelles ou sensibles.
        </p>
        <p>
          Il est interdit de créer un compte usurpant l'identité d'un tiers ou
          présentant de façon trompeuse un lien avec une personne ou entité.
        </p>

        <h3>Respect du code de déontologie des psychologues</h3>
        <br />
        <p>
          Tout contenu diffusé sur R’Cog devra être effectué dans le respect du
          <a
            href="www.codededeontologiedespsychologues.fr/IMG/pdf/Code_deontologie_psychologue_9-09-2021.pdf"
            >code de déontologie des psychologues dans sa dernière version</a
          >. Face à tout manquement au respect de ce code, le cas échéant, nous
          pouvons supprimer, limiter ou bloquer la distribution des contenus et
          des comptes utilisateurs responsables et cela sans préavis.
        </p>
        <p>
          Dans le respect du code de déontologie des psychologues nous
          supprimons :
        </p>
        <ul>
          <li>
            Les informations ou allusions personnelles des patients pouvant
            porter atteinte à leur vie privée (prénom, nom, service médical
            etc.) ou tout manquement au secret professionnel ;
          </li>
          <li>
            Toutes illustrations (photos, vidéo, pdf) sur lesquelles figurent
            entièrement ou partiellement une personne autre que l’auteur de la
            publication ;
          </li>
        </ul>
        <br />
        <h3>Commentaires</h3>
        <br />
        <p>
          Notre Guide d’utilisateurs s'applique aux publications des
          commentaires. Nous pouvons supprimer les comptes associés aux
          publications d’informations non autorisées. Cela inclut :
        </p>
        <ul>
          <li>Tout manquement au code de déontologie des psychologues ;</li>
          <li>Les informations privées ;</li>
          <li>Des chaînes de messages non sollicités ;</li>
          <li>Des critiques employant des propos insultants ;</li>
          <li>Des commentaires et sollicitations de nature sexuelle ;</li>
          <li>
            La promotion de produits ou d'entreprises non sollicitée ou non
            pertinente ;
          </li>
          <li>
            Les remarques haineuses ou humiliantes telles que des commentaires
            sur l'apparence physique ;
          </li>
        </ul>
        <br />
        <h3>Droits de propriété intellectuelle et autres droits</h3>
        <br />
        <p>
          Pour veiller au respect des droits de chacun, il est interdit de :
        </p>
        <ul>
          <li>
            Enfreindre les droits d'autrui, notamment les droits de propriété
            intellectuelle et les droits relatifs au respect de la vie privée.
          </li>
          <li>
            Effectuer une action ou publier des contenus contraires à la loi ou
            à la réglementation en vigueur.
          </li>
          <li>Utiliser le nom ou le logo de R’Cog sans notre accord.</li>
        </ul>
        <br />
        <h3>
          Sécurité et accès au site
        </h3>
        <br />
        <p>
          Pour assurer la sécurité de R’Cog, nous vous demandons de :
        </p>
        <ul>
          <li>Ne pas accéder, modifier ou utiliser nos systèmes.</li>
          <li>
            N'enfreignez pas et ne contournez pas nos mesures de sécurité et ne
            testez pas la vulnérabilité de nos systèmes ou réseaux.
          </li>
          <li>
            Ne pas utiliser une méthode non justifiée ou frauduleuse pour
            accéder, rechercher, retirer, télécharger ou changer R’Cog ou son
            contenu.
          </li>
          <li>
            Ne pas tenter de nuire à un utilisateur, un hôte ou un réseau de
            R’Cog, par exemple en diffusant un virus ou un rançongiciel, en
            provoquant une surcharge, en envoyant du spam ou un très gros volume
            d'e-mails.
          </li>
          <li>
            Ne pas collecter ou stocker des données personnelles de R’Cog ou de
            ses utilisateurs sans leur autorisation.
          </li>
          <li>
            Ne pas partager votre mot de passe, autoriser un tiers à accéder à
            votre compte ou menacer d'une autre façon la sécurité de votre
            compte.
          </li>
          <li>
            Ne tentez pas de vendre l'accès à votre compte ou vos noms
            d'utilisateur et ne les transférez pas de quelque façon que ce soit
            contre dédommagement.
          </li>
        </ul>
        <br />
        <h2>Annexe 2 - Politique relative aux droits d‘auteurs</h2>
        <br />
        <h3>Droits d’auteurs</h3>
        <p>
          R’Cog respecte les droits de propriété intellectuelle d'autrui et nous
          attendons des utilisateurs de R’Cog qu'ils en fassent de même. Notre
          politique consiste, dans certaines circonstances et à notre
          discrétion, à suspendre ou clôturer les comptes des personnes qui ne
          respectent pas ou sont accusées de ne pas respecter à plusieurs
          reprises les droits d'auteurs ou autres droits de propriété
          intellectuelle.
        </p>
        <p>
          R’Cog utilise un système de licence en Creative Commons. Celle-ci à
          l’avantage d’être gratuite, internationale, libre de droit et nous
          permet de protéger le contenu des utilisateurs d’une éventuelle
          réutilisation commerciale. Tous les contenus utilisateurs sur R’Cog
          seront régis sous ces licences.
        </p>
        <p>Plusieurs cas de figure existent avec le Creative Commons :</p>
        <ul>
          <li>
            <b
              >L’attribution (BY) : ceux qui utilisent les œuvres doivent
              créditer l’auteur de la manière dont celui-ci le demande ;</b
            >
          </li>
          <li>
            <b>Pas d’utilisation commerciale (NC) :</b> aucune utilisation
            commerciale de l’œuvre n’est autorisée ;
          </li>
          <li>
            <b>Le partage dans les mêmes conditions (SA) :</b> toute publication
            d’adaptation de l’œuvre par une personne doit être effectuée dans
            les mêmes conditions de licence que l’œuvre originale ;
          </li>
          <li>
            <b>Pas de modification (ND) : </b>seule la diffusion et la
            reproduction de l’original de l’œuvre sont autorisées.
          </li>
        </ul>
        <br />
        <p>
          Le contenu utilisateur de R’Cog répond à une attribution BY-NC-SA.
          Cette licence permet à d'autres personnes de remixer, d'adapter et de
          s'appuyer sur votre travail de manière non commerciale, à condition
          qu'elles vous créditent et concèdent leurs nouvelles créations sous
          les mêmes conditions de licence. Le code juridique complet de cette
          licence est disponible
          <a
            href="https://creativecommons.org/licenses/by-nc-sa/4.0/legalcode.fr"
            >ici</a
          >
        </p>
        <span>
          <v-img :src="logoCC" style="margin:auto" width="120px" />
        </span>
        <p><b>En d'autres termes : </b></p>

        <p>Pour tout contenu disponible sur R'Cog :</p>
        <ul>
          <li>
            <i class="fab fa-creative-commons-by" style="font-size: 23px;"></i>
            Vous devrez créditer l’auteur et indiquer si des modifications ont
            été apportées. Vous pouvez faire cela de n’importe quelle manière
            raisonnable, mais ne suggérez d’aucune façon que le propriétaire de
            la licence de départ endosse la responsabilité pour vous et votre
            utilisation.
          </li>
          <li>
            <i class="fab fa-creative-commons-sa" style="font-size: 23px;"></i>
            Si vous modifiez, remixez, transformez ou construisez sur le
            matériel de quelqu’un d’autre, votre contribution devra être
            partagée sous la même licence que l’originale.
          </li>
          <li>
            <i
              class="fab fa-creative-commons-nc-eu"
              style="font-size: 23px;"
            ></i>
            Vous ne pourrez pas utiliser le matériel partagé à des fins
            commerciales.
          </li>
        </ul>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
export default {
  name: "About",
  data: () => ({
    logoCC: require("@/assets/by-nc-sa.eu_.png")
  })
};
</script>
